if (!customElements.get('zoyo-product-summary')) {
  customElements.define(
    'zoyo-product-summary',
    class ZoyoProductSummary extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber?.();
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      handleVariantChange(event) {
        const { sectionId, html, source } = event.data;
        const productInfo = this.closest('product-info');
        if (source && source !== productInfo) return;
        const originalSectionId = productInfo?.dataset.originalSection || this.dataset.sectionId;
        if (sectionId !== originalSectionId) return;

        const replacement = html.getElementById(`ZoyoProductSummary-${originalSectionId}`);
        if (!replacement) return;

        const renderedSectionId = productInfo?.dataset.section || this.dataset.sectionId;
        this.innerHTML = replacement.innerHTML.replaceAll(originalSectionId, renderedSectionId);
        this.classList.remove('hidden');
      }
    }
  );
}
